<template>
    <v-list class="mt-0" nav flat>
        <template v-for="(item, index) in navbar">
            <v-list-item
                v-if="!item.child"
                :key="index"
                :to="item.path"
                active-class="indigo-blue shadow white--text"
            >
                <v-list-item-action class="mr-4">
                    <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>

            <template v-if="item && item.child && item.child.length > 0">
                <v-list-group :key="index" color="deep-purple">
                    <template v-slot:activator>
                        <v-list-item-action class="mr-4">
                            <v-icon>{{ item.icon }}</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title
                                v-text="item.title"
                            ></v-list-item-title>
                        </v-list-item-content>
                    </template>

                    <v-list-item
                        v-for="(c, index) in item.child"
                        :key="index"
                        :to="c.path"
                        active-class="indigo-blue shadow white--text"
                    >
                        <v-list-item-action class="mr-4"> </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title
                                v-text="c.title"
                            ></v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list-group>
            </template>
        </template>
    </v-list>
</template>

<script>
export default {
    data: () => ({}),

    computed: {
        navbar() {
            let menu;
            let role = this.userRole;
            switch (role) {
                case "superadmin":
                    menu = [
                        {
                            icon: "mdi-account-group",
                            title: "Data Akun",
                            path: "/app/data-akun",
                            child: false
                        },
                        // {
                        //   icon: "mdi-cog",
                        //   title: "Config",
                        //   path: "/app/config",
                        //   child: false,
                        // },
                        {
                            icon: "mdi-cog",
                            title: "Config",
                            child: [
                                { title: "Data PTK", path: "/app/config" },
                                {
                                    title: "Penginputan",
                                    path: "/app/config-penginputan"
                                }
                            ]
                        },
                        {
                            icon: "mdi-chart-scatter-plot-hexbin",
                            title: "Export Excel",
                            path: "/app/export-excel",
                            child: false
                        },
                        {
                            icon: "mdi-compass-rose",
                            title: "Master",
                            child: [
                                {
                                    title: "Tahun Ajaran",
                                    path: "/app/tahun-ajaran"
                                },
                                {
                                    title: "Bidang Guru",
                                    path: "/app/data-bidang-guru"
                                },
                                {
                                    title: "Mapel",
                                    path: "/app/mata-pelajaran"
                                },
                                {
                                    title: "Jenis Tendik",
                                    path: "/app/data-jenis-tendik"
                                },
                                {
                                    title: "Rombel Tingkat",
                                    path: "/app/rombel-tingkat"
                                },
                                {
                                    title: "Pangkat Guru",
                                    path: "/app/pangkat-guru"
                                },
                                {
                                    title: "Pangkat Tendik",
                                    path: "/app/pangkat-tendik"
                                },
                                {
                                    title: "Daftar Berkas",
                                    path: "/app/daftar-berkas"
                                },
                                {
                                    title: "Tugas Tambahan",
                                    path: "/app/tugas-tambahan"
                                },
                                {
                                    title: "Alasan Keluar",
                                    path: "/app/alasan-keluar"
                                },
                                {
                                    title: "Kec. & Kel.",
                                    path: "/app/data-kec-kel"
                                },
                                { title: "Agama", path: "/app/agama" },
                                { title: "Dinas", path: "/app/dinas" }
                            ]
                        },
                        {
                            icon: "mdi-backup-restore",
                            title: "Backup",
                            path: "/app/backup",
                            child: false
                        },
                        {
                            icon: "mdi-alert-circle",
                            title: "App Info",
                            path: "/app/app-info",
                            child: false
                        }
                    ];
                    break;
                case "admin":
                    menu = [
                        {
                            icon: "mdi-view-dashboard",
                            title: "Dashboard",
                            path: "/app/dashboard",
                            child: false
                        },
                        {
                            icon: "mdi-chart-scatter-plot-hexbin",
                            title: "Data Input Terakhir",
                            path: "/app/data-input-terakhir",
                            child: false
                        },
                        {
                            icon: "mdi-account-group",
                            title: "Data Akun",
                            path: "/app/data-akun",
                            child: false
                        },
                        {
                            icon: "mdi-domain",
                            title: "Sekolah",
                            child: [
                                {
                                    title: "Semua Sekolah",
                                    path: "/app/semua-sekolah"
                                },
                                {
                                    title: "Peta Sekolah",
                                    path: "/app/peta-sekolah"
                                }
                            ]
                        },
                        {
                            icon: "mdi-account-tie",
                            child: [
                                {
                                    title: "Semua Guru",
                                    path: "/app/semua-guru"
                                },
                                {
                                    title: "Semua Tendik",
                                    path: "/app/semua-tendik"
                                },
                                {
                                    title: "Semua Kepsek",
                                    path: "/app/semua-kepsek"
                                }
                            ],
                            title: "Data PTK"
                        },
                        {
                            icon: "mdi-rotate-3d-variant",
                            child: [
                                {
                                    title: "Mutasi Guru",
                                    path: "/app/semua-mutasi-guru"
                                },
                                {
                                    title: "Mutasi Tendik",
                                    path: "/app/semua-mutasi-tendik"
                                }
                            ],
                            title: "Data Mutasi"
                        },
                        {
                            icon: "mdi-bank-transfer-out",
                            child: [
                                {
                                    title: "Guru Keluar",
                                    path: "/app/semua-guru-keluar"
                                },
                                {
                                    title: "Tendik Keluar",
                                    path: "/app/semua-tendik-keluar"
                                }
                            ],
                            title: "Data Keluar"
                        },
                        {
                            icon: "mdi-bullhorn",
                            title: "Info Singkat",
                            path: "/app/info-singkat",
                            child: false
                        },
                        {
                            icon: "mdi-calendar",
                            title: "Kalender Pendidikan",
                            path: "/app/kalender-pendidikan",
                            child: false
                        },
                        {
                            icon: "mdi-compass-rose",
                            title: "Master",
                            child: [
                                // { title: "Tahun Ajaran", path: "/app/tahun-ajaran" },
                                {
                                    title: "Bidang Guru",
                                    path: "/app/data-bidang-guru"
                                },
                                {
                                    title: "Mapel",
                                    path: "/app/mata-pelajaran"
                                },
                                {
                                    title: "Jenis Tendik",
                                    path: "/app/data-jenis-tendik"
                                },
                                {
                                    title: "Rombel Tingkat",
                                    path: "/app/rombel-tingkat"
                                },
                                // { title: "Pangkat Guru", path: "/app/pangkat-guru" },
                                // { title: "Pangkat Tendik", path: "/app/pangkat-tendik" },
                                // {
                                //   title: "Daftar Berkas",
                                //   path: "/app/daftar-berkas",
                                // },
                                {
                                    title: "Tugas Tambahan",
                                    path: "/app/tugas-tambahan"
                                },
                                // {
                                //   title: "Alasan Keluar",
                                //   path: "/app/alasan-keluar",
                                // },
                                // { title: "Kec. & Kel.", path: "/app/data-kec-kel" },
                                // { title: "Agama", path: "/app/agama" },
                                // { title: "Dinas", path: "/app/dinas" },
                                { title: "Kontak Aduan", path: "/app/kontak" }
                            ]
                        },
                        {
                            icon: "mdi-file-chart",
                            title: "Laporan",
                            child: [
                                {
                                    title: "Data Sekolah",
                                    path: "/app/laporan-data-sekolah"
                                },
                                {
                                    title: "Sertifikasi Guru",
                                    path: "/app/laporan-sertifikasi-guru"
                                },
                                // {
                                //   title: "Kekurangan Guru",
                                //   path: "/app/laporan-data-kekurangan-guru",
                                // },
                                {
                                    title: "Calon Guru Pensiun",
                                    path: "/app/laporan-calon-guru-pensiun"
                                }
                                // {
                                //   title: "Calon Tendik Pensiun",
                                //   path: "/app/laporan-calon-tendik-pensiun",
                                // },
                            ]
                        },
                        {
                            icon: "mdi-alert-circle",
                            title: "App Info",
                            path: "/app/app-info",
                            child: false
                        }
                    ];
                    break;
                case "ops":
                    menu = [
                        {
                            icon: "mdi-view-dashboard",
                            title: "Dashboard",
                            path: "/app/dashboard",
                            child: false
                        },
                        {
                            icon: "mdi-chart-bubble",
                            child: [
                                {
                                    title: "Profile Umum",
                                    path: "/app/profile-umum"
                                },
                                {
                                    title: "Titik Koordinat",
                                    path: "/app/titik-koordinat"
                                },
                                {
                                    title: "Visi & Misi",
                                    path: "/app/visi-misi"
                                },
                                {
                                    title: "Struktur Organiasi",
                                    path: "/app/struktur-organisasi"
                                }
                            ],
                            title: "Profile Sekolah"
                        },
                        {
                            icon: "mdi-calendar",
                            title: "Kalender Pendidikan",
                            path: "/app/kalender-pendidikan",
                            child: false
                        },
                        {
                            icon: "mdi-account-tie",
                            child: [
                                {
                                    title: "Guru Disetujui",
                                    path: "/app/guru-disetujui"
                                },
                                {
                                    title: "Pengajuan Guru",
                                    path: "/app/pengajuan-guru"
                                },
                                {
                                    title: "Guru Non Induk",
                                    path: "/app/guru-non-induk"
                                }
                            ],
                            title: "Data Guru"
                        },
                        {
                            icon: "mdi-account-tie",
                            child: [
                                {
                                    title: "Tendik Disetujui",
                                    path: "/app/tendik-disetujui"
                                },
                                {
                                    title: "Pengajuan Tendik",
                                    path: "/app/pengajuan-tendik"
                                }
                            ],
                            title: "Data Tendik"
                        },
                        {
                            icon: "mdi-book-education",
                            title: "Rombel Sekolah",
                            path: "/app/rombel-sekolah",
                            child: false
                        },
                        {
                            icon: "mdi-account-question",
                            title: "Cari Kebutuhan Guru",
                            path: "/app/cari-kebutuhan-guru",
                            child: false
                        },
                        {
                            icon: "mdi-airballoon",
                            child: [
                                {
                                    title: "Mutasi Guru",
                                    path: "/app/mutasi-guru"
                                },
                                {
                                    title: "Mutasi Tendik",
                                    path: "/app/mutasi-tendik"
                                }
                            ],
                            title: "Data Mutasi"
                        },
                        {
                            icon: "mdi-bank-transfer-out",
                            child: [
                                {
                                    title: "Guru Keluar",
                                    path: "/app/guru-keluar"
                                },
                                {
                                    title: "Tendik Keluar",
                                    path: "/app/tendik-keluar"
                                }
                            ],
                            title: "Data Keluar"
                        },
                        {
                            icon: "mdi-help-circle",
                            title: "Kontak Aduan",
                            path: "/app/kontak-aduan",
                            child: false
                        },
                        {
                            icon: "mdi-alert-circle",
                            title: "App Info",
                            path: "/app/app-info",
                            child: false
                        }
                    ];
                    break;
                case "dev":
                    menu = [
                        {
                            icon: "mdi-compass-rose",
                            title: "Master",
                            child: [
                                {
                                    title: "Jenjang Sekolah",
                                    path: "/app/jenjang-sekolah"
                                },
                                {
                                    title: "Status Pegawai",
                                    path: "/app/status-pegawai"
                                },
                                {
                                    title: "Daftar Pendidikan",
                                    path: "/app/daftar-pendidikan"
                                }
                            ]
                        },
                        {
                            icon: "mdi-backup-restore",
                            title: "Backup",
                            path: "/app/backup",
                            child: false
                        },
                        {
                            icon: "mdi-alert-circle",
                            title: "App Info",
                            path: "/app/app-info",
                            child: false
                        }
                    ];
                    break;
                default:
                    menu = [];
                    break;
            }

            return menu;
        },
        userRole() {
            return this.$store.getters["auth/getUserRole"];
        }
    }
};
</script>

<style></style>
